import axios from 'axios'

import { handleRequestError } from './request'

export const REQUEST_DONATIONS = 'REQUEST_DONATIONS'
export const RECEIVE_DONATIONS = 'RECEIVE_DONATIONS'

export const requestDonations = (taxReturnId) => (dispatch) => {
    dispatch({ type: REQUEST_DONATIONS, data: { taxReturnId } })

    axios
        .get(`/donations?taxReturnId=${taxReturnId}`)
        .then((response) => {
            const responseData = response?.data || []
            dispatch(
                receiveDonations({
                    fetchSuccessful: true,
                    items: responseData,
                })
            )
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveDonations({ fetchSuccessful: true }))
                return
            }

            dispatch(receiveDonations({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

const receiveDonations = (data) => ({ type: RECEIVE_DONATIONS, data })
